import {
  axiosInstancePromotion,
  CustomResponseFormat,
} from "./instancePromotion";

// OAuth 풀페이지 리다이렉트를 견디도록 레퍼럴 코드를 localStorage 에 보관한다.
// 진입(/with/:code) 시 저장하고, 로그인 완료 시점에 소비(전송 후 제거)한다.
// 키 "값"은 기존 배포분이 저장해 둔 코드(최대 어트리뷰션 3일)와의 호환을 위해 구명칭을 유지한다.
export const REFERRAL_CODE_STORAGE_KEY = "AFFILIATE_REFERRAL_CODE";

export const REFERRAL_DOMAIN = "referral";

export const REFERRAL_SAVE_ENDPOINT = "save";
export const REFERRAL_VALIDATE_ENDPOINT = "validate";

// 혜택 유형: affiliate=제휴(크리에이터 정산 대상) / discount=단순할인
export type ReferralCodeType = "affiliate" | "discount";

// 게이트 검증 응답: isValid=유효 여부, isExpired=기간 만료 여부(만료 안내 화면 분기용),
// name=화면 노출용 제휴사 이름(코드 아님),
// endAt=혜택 종료 일시(서버 표준 "yyyy-MM-dd'T'HH:mm:ss" 문자열, 무기한이면 null), type=혜택 유형.
export type ReferralInfo = {
  isValid: boolean;
  isExpired?: boolean;
  name?: string | null;
  displayName?: string | null;
  endAt?: string | null;
  type?: ReferralCodeType | null;
};

export const referralApi = {
  saveReferralCode: (code: string) =>
    axiosInstancePromotion.post<void>(
      `${REFERRAL_DOMAIN}/${REFERRAL_SAVE_ENDPOINT}`,
      {
        code: code,
      }
    ),

  // 비인증(로그인 전) 게이트 유효성 검사 — 유효 여부 + 표시용 제휴사 이름 반환
  validate: (code: string) =>
    axiosInstancePromotion.get<CustomResponseFormat<ReferralInfo>>(
      `${REFERRAL_DOMAIN}/${REFERRAL_VALIDATE_ENDPOINT}`,
      { params: { code } }
    ),
};
